import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '@/components/dashboard/Dashboard';
import LoginPage from '@/components/login/LoginPage';
import ProjectSteps from '@/components/project/ProjectSteps';
import IdentifyOptions from '@/components/identifyOptions/IdentifyOptions';
import AddScenarii from '@/components/addScenarii/AddScenarii';
import SetUpScenario from '@/components/setUpScenario/SetUpScenario';
import IdentifyContradictoryOptions from '@/components/identifyContradictoryOptions/IdentifyContradictoryOptions';
import IncompatibleScenarii from '@/components/incompatibleScenarii/IncompatibleScenarii';
import ScenarioElements from '@/components/scenarioElements/ScenarioElements';
import ConflictResolution from '@/components/conflictResolution/ConflictResolution';
import SearchPage from '@/components/searchPage/SearchPage';
import ScenariiList from '@/components/scenariiList/ScenariiList';
import AdvancedTestProject from '@/components/testProject/TestAdvancedMode';
import SourcesAndDeployments from '@/components/sourcesAndDeployments/SourcesAndDeployments';
import SourceViewer from '@/components/sourcesAndDeployments/SourceViewer';
import UploadSource from '@/components/sourcesAndDeployments/UploadSource';
import GenerateSource from '@/components/sourcesAndDeployments/GenerateSource';
import DeploymentDetails from '@/components/sourcesAndDeployments/DeploymentDetails';
import Accounts from '@/components/accounts/Accounts';
import AccountDetails from '@/components/accounts/AccountDetails';
import Billing from '@/components/accounts/Billing';
import NotFound from '@/components/global/NotFound';

import { Auth } from '@aws-amplify/auth';

Vue.use(Router);

// TODO: externaliser quand on aura besoin de plusieurs navigation guards
function isUserAuthenticated (to, from, next) {
  Auth.currentSession().then(() => {
    if (to.name === 'login') {
      next({ name: 'dashboard' });
    }
    next();
  }).catch(err => {
    // TODO: a voir, peut-etre affiner ce check
    console.log("error : ", err);
    next({ name: 'login' });
  });
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage,
    },
    {
      path: '/projects/search/:query',
      name: 'searchProjects',
      component: Dashboard,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id',
      name: 'projectSteps',
      component: ProjectSteps,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/identifyOptions',
      name: 'identifyOptions',
      component: IdentifyOptions,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/addScenarii/:beliefId?',
      name: 'addScenarii',
      component: AddScenarii,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/addOptionsToScenario/:scenarioId',
      name: 'addOptionsToScenario',
      component: SetUpScenario,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/identifyContradictoryOptions',
      name: 'identifyContradictoryOptions',
      component: IdentifyContradictoryOptions,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/incompatibleScenarii/:scenarioId?',
      name: 'incompatibleScenarii',
      component: IncompatibleScenarii,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/scenarioElements',
      name: 'scenarioElements',
      component: ScenarioElements,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/conflictResolution',
      name: 'conflictResolution',
      component: ConflictResolution,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/resolveConflictsInCombinationsOfMinimumScenarios',
      name: 'conflictResolutionInCombination',
      component: ConflictResolution,
      props: { 'shortcutToOption4': true },
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/resolveConflictsInCombinationsOfMinimumScenariosForBeliefs/:beliefId',
      name: 'conflictResolutionInCombinationForBeliefs',
      component: ConflictResolution,
      props: { 'shortcutToOption4': true, 'beliefMode': true },
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/searchPage',
      name: 'searchPage',
      component: SearchPage,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/scenariiList',
      name: 'scenariiList',
      component: ScenariiList,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/test',
      name: 'advancedTest',
      component: AdvancedTestProject,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/sourcesAndDeployments',
      name: 'sourcesAndDeployments',
      component: SourcesAndDeployments,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/sources/:sourceId',
      name: 'sourceViewer',
      component: SourceViewer,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/sources',
      name: 'uploadSource',
      component: UploadSource,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/generateSource',
      name: 'generateSource',
      component: GenerateSource,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/deploymentDetails/:deploymentId',
      name: 'deploymentDetails',
      component: DeploymentDetails,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/projects/:id/newDeployment/:sourceId',
      name: 'newDeployment',
      component: DeploymentDetails,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/accounts',
      name: 'accounts',
      component: Accounts,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/accounts/new',
      name: 'newAccount',
      component: AccountDetails,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/accounts/:accountId',
      name: 'accountDetails',
      component: AccountDetails,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/accounts/:accountId/billing',
      name: 'billing',
      component: Billing,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '/accounts/:accountId/billing/:period',
      name: 'billingPeriod',
      component: Billing,
      beforeEnter: isUserAuthenticated,
    },
    {
      path: '*',
      name: '4040NotFound',
      component: NotFound,
      beforeEnter: isUserAuthenticated,
    }
  ],
});
